export default __webpack_public_path__ + "static/media/745.f236ea49.gif";